<template>
	<v-form @keydown.enter.prevent>
		<v-container v-if="isEdit">
			<v-layout row wrap>
				<v-subheader class="tag-desc mb-3 text-xs-left">
					Tags are a great way to further categorise employees. Tags can be used to filter employees in other areas of the system. You could use tags to associate employees with office location, position type, or a project team they're
					working on.
				</v-subheader>
				<tag-items :tags="value" :tag-list="tagList" @onAddTag="onAddTag" @onRemoveTag="onRemoveTag" />
			</v-layout>
		</v-container>
		<v-container v-else>
			<v-layout row wrap>
				<v-subheader class="tag-desc mb-3 text-xs-left">
					Tags are a great way to further categorise employees. Tags can be used to filter employees in other areas of the system. You could use tags to associate employees with office location, position type, or a project team they're
					working on.
				</v-subheader>
				<tag-items :tags="value" :tag-list="tagList" read-only />
			</v-layout>
		</v-container>
	</v-form>
</template>

<script>
	import { mapGetters } from 'vuex';
	import formMixin from '@/mixins/employeeFormMixin';
    import TagItems from '@/components/tags/TagItems';

	export default {
        components: {
            TagItems
        },
		mixins: [formMixin],
        computed: {
            ...mapGetters({
				tagList: 'tags/employeeTagList'
			}),
        },
        methods: {
            onAddTag(newTagName) {
				this.value.push({
					id: this.newGuid(),
					name: newTagName
				});
			},
			onRemoveTag(tagId) {
				const index = this.value.findIndex(x => x.id === tagId);
				if (index > -1) {
					this.value.splice(index, 1);
				}
			},
        }
	};
</script>

<style scoped>
	.tag-desc {
		height: inherit;
		padding-left: 0;
	}
</style>